import palette from '../palette';

export default {
  root: {
    '&.MuiStepIcon-active': {
      color: palette.secondary.main
    }
  }
};
